import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, ResponseContentType } from '@angular//http';
import { User } from '../_models/index';
import 'rxjs/add/operator/toPromise';
import { AuthHttp } from 'angular2-jwt';
import { environment } from '../../environments/environment';

@Injectable()

export class ManagePermissionsServices {

    backendUrl: any;
    TOKEN: any;
    headers: any;
    options: any;
    secret: any;

    api = "/managepermissions/"

    constructor(private http: AuthHttp) {
        // this.backendUrl = environment.url;
        this.backendUrl=window.location.origin
        this.backendUrl+="/apis"
        this.secret = environment.secret;
    }


    getallACLRolesConfiguration() {
        return this.http.get(`${this.backendUrl}${this.api}all-acl-role-data/` , this.jwt_new()).map((response: Response) => response.json());
    }

    getallNavigationConfiguration() {
        return this.http.get(`${this.backendUrl}${this.api}all-acl-navigation-data/` , this.jwt_new()).map((response: Response) => response.json());
    }

     getallACLRoutesConfiguration(id:any) {
        return this.http.get(`${this.backendUrl}${this.api}all-acl-route-data/${id}` , this.jwt_new()).map((response: Response) => response.json());
    }

    getallACLSubRoutesConfiguration() {
        return this.http.get(`${this.backendUrl}${this.api}all-acl-sub-route-data/` , this.jwt_new()).map((response: Response) => response.json());
    }

    getallCampaignsData() {
        return this.http.get(`${this.backendUrl}${this.api}all-campaigns-data/` , this.jwt_new()).map((response: Response) => response.json());
    }

    getallQuickReplyData() {
        return this.http.get(`${this.backendUrl}${this.api}all-quick-reply-data/` , this.jwt_new()).map((response: Response) => response.json());
    }

    AddUpdateQRCampaignsDataConfiguration(data) {
        return this.http.post(`${this.backendUrl}${this.api}add-update-configuration/` ,data, this.jwt_new()).map((response: Response) => response.json());
    }

    getRoleMappingDataById(id:any) {
        return this.http.get(`${this.backendUrl}${this.api}all-rolemappingById-data/${id}` , this.jwt_new()).map((response: Response) => response.json());
    }

     AddUpdateACLRolesDataConfiguration(data) {
        return this.http.post(`${this.backendUrl}${this.api}add-update-acl-roles-configuration/` ,data, this.jwt_new()).map((response: Response) => response.json());
    }

    getACLMappingDataById(id:any,menu_id:any) {
        return this.http.get(`${this.backendUrl}${this.api}get-ACL-mapping-data/${id}/${menu_id}` , this.jwt_new()).map((response: Response) => response.json());
    }

    deleteACLMappingDataById(data) {
        return this.http.post(`${this.backendUrl}${this.api}deleteACL-mapping-data-id/` ,data, this.jwt_new()).map((response: Response) => response.json());
    }

    deleteACLParentId(data) {
        return this.http.post(`${this.backendUrl}${this.api}deleteACL-parent-id/` ,data, this.jwt_new()).map((response: Response) => response.json());
    }

    private jwt_new() {
        this.TOKEN = (localStorage.getItem('id_token') != undefined) ? localStorage.getItem('id_token') : localStorage.getItem('login_token');
        this.headers = new Headers({ 'Content-Type': 'application/json' });
        this.headers.append('Authorization', this.TOKEN)
        this.options = new RequestOptions({ headers: this.headers });
        return this.options;
    }

    private jwt() {
        // create authorization header with jwt token
        this.TOKEN = (localStorage.getItem('id_token') != undefined) ? localStorage.getItem('id_token') : localStorage.getItem('login_token');
        let headers = new Headers({ 'Authorization': this.TOKEN });
        return new RequestOptions({ headers: headers });
    }
}


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/_services/managepermissions.service.ts